module.exports = __webpack_public_path__ + "img/Home-blackgoldflowermarble.b564e306.jpg";